<template>
  <div style="height: 100%;background-color: #fbfbfb;overflow-y: auto">
    <div style="height: 20px"></div>
    <div v-if="!isAdd" style="margin: 0 20px;height: 35px;">
      <el-button size="mini" type="primary" @click="noEdit = !noEdit">修改</el-button>
    </div>
    <el-form :model="entity" ref="entity" :rules="entityRules" label-width="140px" class="demo-ruleForm">
      <div class="title-bg">&nbsp;&nbsp;&nbsp;基本信息</div>
      <el-row style="margin-top: 10px;margin-right: 20px">
        <el-col :span="8">
          <el-form-item label="机构名称" prop="entity_name">
            <el-input :disabled="noEdit" v-model="entity.entity_name" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="统一社会信用代码" prop="entity_organization_code">
            <el-input :disabled="noEdit" v-model="entity.entity_organization_code" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="成立日期" prop="entity_establish_date">
            <el-date-picker v-fixZoom style="width: 100%;" :disabled="noEdit" v-model="entity.entity_establish_date" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-right: 20px">
        <el-col :span="8">
          <el-form-item label="机构性质" prop="entity_nature_code">
            <el-radio-group :disabled="noEdit" v-model="entity.entity_nature_code">
              <el-radio label="1">公办</el-radio>
              <el-radio label="2">民办</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="机构类型" prop="investor_nature_code">
            <el-select v-fixZoom :disabled="noEdit" v-model="entity.investor_nature_code" filterable placeholder="请选择" style="width: 100%">
              <el-option v-for="item in typeArr" :key="item.value" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="机构地址" prop="entity_address">
            <el-input :disabled="noEdit" v-model="entity.entity_address" placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-right: 20px">
        <el-col :span="8">
          <el-form-item label="开户名" prop="">
            <el-input :disabled="noEdit" v-model="entity.extra_info.account_name" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="开户行" prop="">
            <el-input :disabled="noEdit" v-model="entity.extra_info.bank_name" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="银行账号" prop="">
            <el-input :disabled="noEdit" v-model="entity.extra_info.bank_account" placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="title-bg">&nbsp;&nbsp;&nbsp;场所信息</div>
      <el-row style="margin-top: 10px;margin-right: 20px">
        <el-col :span="8">
          <el-form-item label="占地面积（m²）" prop="">
            <el-input type="number" :disabled="noEdit" v-model="entity.extra_info.floor_space" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="总床位数" prop="">
            <el-input type="number" :disabled="noEdit" v-model="entity.approved_bed_count" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="房屋使用形式" prop="">
            <el-select v-fixZoom :disabled="noEdit" v-model="entity.extra_info.use_type" filterable placeholder="请选择" style="width: 100%">
              <el-option v-for="item in houseTypeArr" :key="item.value" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="收住对象" prop="">
        <el-checkbox-group :disabled="noEdit" v-model="entity.extra_info.person_type">
          <el-checkbox v-for="item in typeService" :value="item.id" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <div class="title-bg">&nbsp;&nbsp;&nbsp;机构联系人信息</div>
      <el-row style="margin-top: 10px;margin-right: 20px">
        <el-col :span="8">
          <el-form-item label="法人姓名" prop="">
            <el-input :disabled="noEdit" v-model="entity.entity_legal_person_name" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="法人身份证号" prop="">
            <el-input :disabled="noEdit" v-model="entity.entity_legal_person_identity_card_number" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="法人联系电话" prop="">
            <el-input :disabled="noEdit" v-model="entity.entity_legal_person_contact_phone" placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-right: 20px">
        <el-col :span="8">
          <el-form-item label="院长姓名" prop="">
            <el-input :disabled="noEdit" v-model="entity.entity_manager_name" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="院长身份证号" prop="">
            <el-input :disabled="noEdit" v-model="entity.entity_manager_identity_card_number" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="院长联系电话" prop="">
            <el-input :disabled="noEdit" v-model="entity.entity_manager_contact_phone" placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row style="margin-right: 20px">
        <el-col :span="8">
          <el-form-item label="民政对接人姓名" prop="">
            <el-input :disabled="noEdit" v-model="entity.extra_info.contact_person" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="民政对接人职务" prop="">
            <el-input :disabled="noEdit" v-model="entity.extra_info.contact_job" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="民政对接人联系电话" prop="">
            <el-input :disabled="noEdit" v-model="entity.extra_info.contact_phone" placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="title-bg">&nbsp;&nbsp;&nbsp;系统信息</div>
      <el-row style="margin-top: 10px;margin-right: 20px">
        <el-col :span="8">
          <el-form-item label="系统名称" prop="">
            <el-input :disabled="noEdit" v-model="entity.system_name" placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin: 0 20px;height: 50px;text-align: right">
      <el-button v-if="!noEdit && isAdd" type="primary" @click="submitAddEdit('entity')">添加机构</el-button>
      <el-button v-if="!noEdit && !isAdd" type="primary" @click="submitAddEdit('entity')">保存修改</el-button>
    </div>
    <div class="title-bg" v-if="!isAdd">&nbsp;&nbsp;&nbsp;电子归档</div>
    <div style="margin: 20px" v-if="!isAdd">
      <el-table size="mini" border :data="tableData" style="width: 100%">
        <el-table-column
          prop="type_name"
          label="文件类型"
          min-width="60">
        </el-table-column>
        <el-table-column
          prop="att_name"
          label="文件名"
          width="180" align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="文件内容"
          min-width="120" align="center">
          <template slot-scope="scope">
            <img style="height: 100px" v-if="scope.row.showUrl !== '' && scope.row.fileType !== 'pdf'" :src="scope.row.showUrl"/>
            <span v-if="scope.row.fileType === 'pdf'">查看详情PDF</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="esp_name"
          label="操作人"
          min-width="70" align="center">
        </el-table-column>
        <el-table-column label="操作" align="center" width="220">
          <template slot-scope="scope">
            <el-button v-if="scope.row.id === 0" size="mini" @click="addBtn(scope.row)" type="primary" plain>上传</el-button>
            <el-button v-if="scope.row.id !== 0" size="mini" @click="seeBtn(scope.row)" type="warning" plain>查看</el-button>
            <el-button v-if="scope.row.id !== 0" size="mini" @click="editBtn(scope.row)" type="success" plain>编辑</el-button>
            <el-button v-if="scope.row.id !== 0" size="mini" @click="delBtn(scope.row)" type="danger" plain>删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog width="500px" :title="addEditTitle" :visible.sync="addEditFile" v-if="addEditFile" append-to-body>
      <div style="text-align: center" v-if="sendForm.id === 0">
        <el-upload class="upload-demo" :limit=limitNum :auto-upload="false" accept="."
                   action="#" :on-change="fileChange" :on-exceed="exceedFile"
                   :on-success="handleSuccess" :on-error="handleError" :on-remove="handleRemoveFile"
                   :file-list="fileList" list-type="text" ref="file">
          <el-button size="mini" icon="el-icon-upload2" type="primary" plain>上传文件</el-button>
          <div slot="tip" class="el-upload__tip" style="color: #999999">只能上传.pdf \ .png \ .jpg文件</div>
        </el-upload>
      </div>
      <el-form style="margin-top: 20px;margin-right: 30px" :model="sendForm" :rules="fileRules" ref="sendForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="文件名" prop="att_name">
          <el-input v-model="sendForm.att_name" placeholder="请输入文件名"></el-input>
        </el-form-item>
      </el-form>
      <div style="margin-top: 30px;height: 50px">
        <el-row style="margin: 0 20px">
          <el-col :span="12">
            <div class="cancel-btn" @click="addEditFile = false">
              <span>取消</span>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="send-btn" @click="submitAddEditFile('sendForm')">
              <span>确定</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-dialog>
    <el-dialog width="900px" :title="addEditTitle" :visible.sync="openFile" v-if="openFile" append-to-body>
      <div style="text-align: center">
        <iframe v-if="sendForm.fileType === 'pdf'" :src="sendForm.uri" height="500px;" width="800px"></iframe>
        <img style="max-width: 100%" v-if="sendForm.uri !== ''" :src="sendForm.uri"/>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  createentity,
  queryentitybyeid,
  queryentityfilelist,
  queryentityfileupdate,
  updateentity,
  uploadfile
} from '../../api/yanglaoyuan'
// import {queryorg} from '../../api/organizer'

export default {
  name: 'organizationInfo',
  props: {
    unitObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      noEdit: true,
      // orgArr: [],
      entityId: 0,
      oldEntity: {},
      entity: {
        'id': 0,
        'entity_id': '',
        'entity_code': '',
        'entity_name': '',
        'entity_organization_code': '',
        'entity_status': '',
        'entity_approval_certificate_number': '',
        'entity_administrative_level': '',
        'entity_administrative_area_code': '',
        'entity_administrative_area_name': '',
        'entity_address': '',
        'entity_postal_code': '',
        'entity_contact_phone': '',
        'entity_establish_date': '',
        'entity_supervision_department_name': '',
        'entity_registration_type_code': '',
        'entity_nature_code': '',
        'entity_legal_person_nature_code': '',
        'entity_type_code': '',
        'entity_level_code': '',
        'entity_service_item_category_code': '',
        'entity_function_classification_code': '',
        'is_included_in_the_waiting_institution': 0,
        'medical_insurance_networking_mode_code': '',
        'is_open_to_Hong_Kong_Macao_and_Taiwan_and_foreigners': 0,
        'medical_care_combination_mode_code': '',
        'entity_legal_person_name': '',
        'entity_legal_person_identity_card_number': '',
        'entity_legal_person_contact_phone': '',
        'entity_manager_name': '',
        'entity_manager_identity_card_number': '',
        'entity_manager_contact_phone': '',
        'entity_application_acceptance_registration_number': '',
        'entity_application_unit_proposed_name': '',
        'entity_application_acceptance_date': '',
        'entity_application_acceptance_unit_name': '',
        'entity_application_review_opinion': '',
        'entity_application_review_unit_name': '',
        'entity_application_approval_result': '',
        'entity_application_approval_unit_name': '',
        'entity_application_approval_document_number': '',
        'entity_application_approval_date': '',
        'entity_application_approval_license_number': '',
        'practice_date': '0000-00-00',
        'approved_bed_count': 0,
        'entity_construction_project_name': '',
        'project_address': '',
        'project_area_name': '',
        'planned_start_time': '',
        'planned_completion_time': '',
        'project_construction_form_code': '',
        'total_project_investment': 0,
        'fire_inspection_acceptance_mark': 0,
        'fire_inspection_acceptance_approval': '',
        'fire_inspection_acceptance_approval_unit_name': '',
        'fire_inspection_acceptance_date': '0000-00-00',
        'automatic_sprinkler_system_setting_mark': 0,
        'automatic_sprinkler_system_detection_valid_mark': 0,
        'automatic_sprinkler_system_detection_unit_name': '',
        'fire_alarm_system_setting_mark': 0,
        'fire_alarm_system_detection_valid_mark': 0,
        'fire_alarm_system_detection_unit_name': '',
        'fire_safety_inspection_date': '',
        'fire_safety_inspection_unit_name': '',
        'project_preliminary_procedure_code': '',
        'project_construction_civil_engineering_code': '',
        'project_decoration_road_greening_code': '',
        'project_implementation_equipment_addition_code': '',
        'project_fire_safety_certificate_processing_code': '',
        'project_catering_service_license_processing_code': '',
        'project_environmental_assessment_report_processing_code': '',
        'project_establishment_license_processing_code': '',
        'project_operation_code': '',
        'public_utilities_fee_discount_mark_water': false,
        'public_utilities_fee_discount_mark_electricity': false,
        'public_utilities_fee_discount_mark_gas': false,
        'public_utilities_fee_discount_mark_cable_tv': false,
        'business_tax_discount_code': '',
        'enterprise_income_tax_discount_code': '',
        'investor_or_project_constructor_name': '',
        'investor_type_code': '',
        'investor_nature_code': '',
        'investor_or_project_constructor_phone': '',
        'investor_or_project_constructor_address': '',
        'investor_or_project_constructor_manager_name': '',
        'investor_or_project_constructor_manager_phone': '',
        'operating_unit_name': '',
        'applicant_name': '',
        'applicant_id_number': '',
        'applicant_phone': '',
        'entity_land_nature': '',
        'land_acquisition_mode': '',
        'land_ownership_proof_code': '',
        'elevator_installation_mark': false,
        'house_attribute_code': '',
        'house_ownership_proof_code': '',
        'signed_elderly_number': 0,
        'male_elderly_number': 0,
        'female_elderly_number': 0,
        'local_city_elderly_number': 0,
        'other_city_elderly_number': 0,
        'non_local_elderly_number': 0,
        'service_people_number': 0,
        'service_people_times': 0,
        'service_complaint_people_number': 0,
        'service_complaint_people_times': 0,
        'total_staff_number': 0,
        'service_staff_number': 0,
        'orgid': 0,
        extra_info: {
          floor_space: '',
          charge_min: '',
          charge_max: '',
          person_type: [],
          account_name: '',
          bank_name: '',
          bank_account: '',
          use_type: '',
          contact_person: '',
          contact_job: '',
          contact_phone: ''
        }
      },
      entityRules: {
        entity_name: [{required: true, message: '请输入机构名称', trigger: 'blur'}],
        entity_organization_code: [{required: true, message: '请输入统一社会信用代码', trigger: 'blur'}],
        entity_establish_date: [{required: true, message: '请选择成立日期', trigger: 'change'}],
        entity_nature_code: [{required: true, message: '请选择机构性质', trigger: 'change'}],
        entity_address: [{required: true, message: '请输入机构地址', trigger: 'blur'}],
        investor_nature_code: [{required: true, message: '请选择机构类型', trigger: 'change'}]
      },
      orgOptions: [],
      typeArr: [],
      houseTypeArr: [],
      typeService: [{id: 1, name: '自理'}, {id: 2, name: '半自理/介护'}, {id: 3, name: '特护'}],
      tableData: [],
      row: '',
      sendForm: {
        'oper_type': 0,
        'id': 0,
        'eid': 0,
        'typeid': 0,
        'oid': 0,
        'oid2': 0,
        'fileid': 0,
        'att_name': '',
        'esp_id': 0,
        'esp_name': ''
      },
      addEditTitle: '',
      addEditFile: false,
      fileForm: {
        sfzPhoto: [],
        fileArr: []
      },
      fileRules: {
        att_name: [{required: true, message: '请输入文件名', trigger: 'blur'}]
      },
      // 图片
      dialogImageUrl: '',
      dialogImageUrlArray: [],
      hideUpload: false,
      dialogVisible: false,
      // pdf
      limitNum: 1, // 上传同时允许上传的最大数
      fileList: [],
      openFile: false,
      fileurl: '',
      // 图片浏览器地址
      baseUrl: '',
      isAdd: false
    }
  },
  created () {
    this.typeArr = this.commonType.getEntityTypeArr()
    this.houseTypeArr = this.commonType.getHouseTypeArr()
    this.baseUrl = this.commonType.getapi()
    if (this.$store.state.user.moduletag === 1) {
      if (this.unitObj.orgRow.entity_id === 0) {
        this.entity.orgid = this.unitObj.orgRow.id
        this.noEdit = false
        this.isAdd = true
      } else {
        this.entityId = this.unitObj.orgRow.entity_id
        this.getUnitData()
      }
    } else if (this.$store.state.user.moduletag === 2) {
      this.entityId = this.$store.state.user.LoginResp.entity_id
      this.getUnitData()
    }
  },
  methods: {
    // 组织
    getUnitData () {
      let data = {
        eid: this.entityId
      }
      queryentitybyeid(data).then(res => {
        let data = this.clone(res.data.entity)
        let info = {
          floor_space: '',
          charge_min: '',
          charge_max: '',
          person_type: [],
          account_name: '',
          bank_name: '',
          bank_account: '',
          use_type: '',
          contact_person: '',
          contact_job: '',
          contact_phone: ''
        }
        if (data.extra_info) {
          let extra = JSON.parse(data.extra_info)
          info.floor_space = extra.floor_space ? extra.floor_space : ''
          info.charge_min = extra.charge_min ? extra.charge_min : ''
          info.charge_max = extra.charge_max ? extra.charge_max : ''
          info.person_type = extra.person_type ? extra.person_type : []
          info.account_name = extra.account_name ? extra.account_name : ''
          info.bank_name = extra.bank_name ? extra.bank_name : ''
          info.bank_account = extra.bank_account ? extra.bank_account : ''
          info.use_type = extra.use_type ? extra.use_type : ''
          info.contact_person = extra.contact_person ? extra.contact_person : ''
          info.contact_job = extra.contact_job ? extra.contact_job : ''
          info.contact_phone = extra.contact_phone ? extra.contact_phone : ''
        }
        data.extra_info = info
        this.entity = data
        this.oldEntity = data
        console.log(data)
        this.getFileTable()
      }).catch(() => {})
    },
    getFileTable () {
      let data = {
        eid: this.entityId,
        id1: this.entityId
      }
      this.tableData = []
      queryentityfilelist(data).then(res => {
        for (let i = 0; i < res.data.arrdata.length; i++) {
          let obj = res.data.arrdata[i]
          if (obj.type_name !== '其他') {
            obj.fileType = obj.uri !== '' ? obj.uri.split('.')[obj.uri.split('.').length - 1] : ''
            obj.showUrl = this.getUrlShow(obj)
            this.tableData.push(obj)
          }
        }
      })
    },
    getUrlShow (obj) {
      let url = ''
      if (obj.uri !== '' && obj.fileType !== 'pdf') {
        url = this.baseUrl + obj.uri.split('/api/v1/web/')[obj.uri.split('/api/v1/web/').length - 1]
      }
      return url
    },
    // 上传文件
    handleSuccess (res, file, fileList) {
      this.$message.success('上传成功')
    },
    // eslint-disable-next-line handle-callback-err
    handleError (err, file, fileList) {
      this.$message.error('上传失败')
    },
    // 文件状态改变时的钩子
    async fileChange (file, fileList) {
      let vm = this
      // this.fileList = []
      let types = ['pdf', 'jpg', 'png']
      if (types.indexOf(file.name.split('.')[file.name.split('.').length - 1]) === -1) {
        vm.$message({type: 'error', message: '不支持该文件类型！'})
        this.$refs['file'].clearFiles()
        return
      }
      let obj = {
        raw: file.raw,
        filename: this.row.type_name,
        domain: window.location.host.indexOf('localhost') === 0 ? 'https://jiaold.com' : window.location.protocol + '//' + window.location.host
      }
      this.$message({message: '正在上传。', type: 'warning', duration: 0})
      uploadfile(obj).then(res => {
        this.$message.closeAll()
        this.$message({ message: '成功上传文件', type: 'success' })
        this.sendForm.fileid = res.data.fileid
        this.sendForm.att_name = file.name
        // console.log('send', this.fileList, file)
      }).catch(() => {
        this.$message.closeAll()
        this.$refs.file.uploadFiles = []
        this.$message({ message: '上传文件失败', type: 'error' })
      })
    },
    // 文件超出个数限制时的钩子
    exceedFile (files, fileList) {
      // this.$message.warning(`只能选择 ${this.limitNum} 个文件，当前共选择了 ${files.length + fileList.length} 个`)
      this.$message.warning(`只能选择 ${this.limitNum} 个文件。`)
    },
    handleRemoveFile (file, fileList) {
      for (let i = 0; i < this.fileList.length; i++) {
        if (this.fileList[i].id === file.id) {
          this.fileList.remove(this.fileList[i])
        }
      }
    },
    submitAddEditFile (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.sendForm.fileid === 0) {
            this.$message({
              message: '请选择文件上传。',
              type: 'warning'
            })
            return
          }
          queryentityfileupdate(this.sendForm).then(res => {
            this.getFileTable()
            if (this.sendForm.oper_type === 0) {
              this.$notify({title: '成功', message: '成功上传文件', type: 'success', duration: 2000})
            } else {
              this.$notify({title: '成功', message: '成功编辑文件', type: 'success', duration: 2000})
            }
            this.addEditFile = false
          }).catch(() => {})
        }
      })
    },
    // 上传附件
    addBtn (row) {
      this.row = row
      this.sendForm = {
        'oper_type': 0,
        'id': 0,
        'eid': parseInt(this.entityId),
        'typeid': row.type_id,
        'oid': 0,
        'oid2': 0, // 入住id
        'fileid': 0,
        'att_name': '',
        'esp_id': this.$store.state.user.syspersonid,
        'esp_name': this.$store.state.user.personname
      }
      this.addEditTitle = '上传文件'
      this.addEditFile = true
    },
    // 查看
    seeBtn (row) {
      this.row = row
      this.sendForm = row
      this.addEditTitle = '【' + row.att_name + '】文件详情'
      this.openFile = true
      console.log(this.sendForm)
    },
    // 编辑附件
    editBtn (row) {
      this.row = row
      this.sendForm = {
        'oper_type': 1,
        'id': row.id,
        'eid': row.eid,
        'typeid': row.type_id,
        'oid': row.oid,
        'oid2': row.oid2, // 入住id
        'fileid': row.fileid,
        'att_name': row.att_name,
        'esp_id': this.$store.state.user.syspersonid,
        'esp_name': this.$store.state.user.personname
      }
      this.addEditTitle = '编辑文件'
      this.addEditFile = true
    },
    delBtn (row) {
      this.sendForm = {
        'oper_type': 2,
        'id': row.id,
        'eid': row.eid,
        'typeid': row.type_id,
        'oid': row.oid,
        'oid2': row.oid2, // 入住id
        'fileid': row.fileid,
        'att_name': row.att_name,
        'esp_id': this.$store.state.user.syspersonid,
        'esp_name': this.$store.state.user.personname
      }
      this.$confirm('此操作将删除该文件【' + row.att_name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        queryentityfileupdate(this.sendForm).then(res => {
          this.getFileTable()
          this.$notify({title: '成功', message: '成功删除文件', type: 'success', duration: 2000})
        }).catch(() => {})
      }).catch(() => {})
    },
    submitAddEdit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.clone(this.entity)
          let info = JSON.stringify(this.entity.extra_info)
          data.extra_info = info
          if (this.entity.approved_bed_count === '') {
            data.approved_bed_count = 0
          } else {
            data.approved_bed_count = parseInt(this.entity.approved_bed_count)
          }
          if (this.isAdd) {
            createentity(data).then(res => {
              this.isAdd = false
              this.$notify({ title: '成功', message: '成功新增机构', type: 'success', duration: 2000 })
              this.$emit('updateTable')
              this.$emit('change', false)
            }).catch(() => {})
          } else {
            updateentity(data).then(res => {
              this.noEdit = !this.noEdit
              this.$notify({title: '成功', message: '成功编辑机构', type: 'success', duration: 2000})
              this.$store.dispatch('update_system_name', data.system_name)
            }).catch(() => {})
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.title-bg{
  height: 40px;
  line-height: 40px;
  font-family: PingFang-SC-Medium;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 2px;
  color: #1a1a1a;
  margin: 0 20px;
  background-image: linear-gradient(left,
  #b6e7ff 0%,
  rgba(182, 231, 255, 0) 100%);
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/organizationInfo.vue